module.exports = __webpack_public_path__ + "static/img/fish54.aa70834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish54.png
// module id = GowX
// module chunks = 0